import styles from "./Index.module.css";

const Index = ({ locations }) => {
  return (
    <>
      <div className={styles.container}>
        <h1> Field Guides </h1>
        <img alt="field-guide-icon" src="/img/numbat_medium_orange.png"></img>
        {/* <h2> Page not found </h2> */}
        <h2>Are you looking for one of these field guides?</h2>
        <ul>
          {locations
            .sort((a, b) => a.title > b.title)
            .map((location) => {
              return (
                <li>
                  <a key={location.slug} href={"/" + location.slug}>
                    {location.title}
                  </a>
                </li>
              );
            })}
        </ul>
      </div>
    </>
  );
};

export default Index;
